import { Controller } from '@hotwired/stimulus';

/**
 * Dibuja un dial (círculo relleno según el porcentaje)
 * Utiliza el componente jquery knob
 */
/* global $ */
export default class extends Controller {
  connect() {
    this.$element = $(this.element);
    const $textArea = this.$element;
    const { text, fontSize, cssCursor } = this.element.dataset;

    this.$element.knob({
      readOnly: true,
      format: function onFormat(value) {
        return text || value;
      },
      draw: function onDraw() {
        if (fontSize) {
          $(this.i).css('font-size', fontSize);
        }
        $textArea.removeClass('hide');
      },
    });

    if (cssCursor) {
      this.$element.css('cursor', cssCursor);
    }
  }
}
